export const environment = {
  apiUrl: "https://nprd-api.brightsidecounseling.org",
  stripePublishableKey:
    "pk_test_51SWQLmLwcIb0q3H85r734uTKTH4bf5B3AsR00ouk09cTrKjB6uiuhehYdPHlFWaqY50iLXW1BspcDCx4Gh9LxCi900IlJb4Y9t",
  config: {
    apiKey: "AIzaSyCldCfKkouixvarOyReqvz-BoUdmqmoNvk",
    authDomain: "brightside-nprd.firebaseapp.com",
    projectId: "brightside-nprd",
    appId: "1:157998629297:web:140d0c49db3d89cfcf3d90",
  },
  tenantId: "patient-portal-r0ex3",
};
